import { createSvgIcon } from "@mui/material";

export const ArrowLeftRightIcon = createSvgIcon(
    <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" fill="none">
        <path d="M5.16667 1L1 5.16667H19.75M15.5833 19.75L19.75 15.5833H1" stroke="black" strokeWidth="2" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>,
    'ArrowLeftRightIcon'
)